import React from "react";
import styles from "./ElixirStats.module.scss";

const STATS = [
  {
    value: "70%",
    label: "Reduction in ‘Where’s my order’ customer queries",
  },
  {
    value: "100%",
    label: "Real-time visibility into shipments on Air, Ocean & Land",
  },
  {
    value: "24/7",
    label: "Customer self-service access to order status & documents",
  },
];

function ElixirStats() {
  return (
    <section className={styles.statsSection}>
      <div className={styles.pill}>
        {STATS.map((stat, i) => (
          <div className={styles.stat} key={i}>
            <span className={styles.value}>{stat.value}</span>
            <span className={styles.label}>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ElixirStats;
